import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { colors, spacing, typography, focusVisible } from '@/styles/designTokens'

export const StyledPopoverContent = styled(Box)(() => ({
	padding: `${spacing.xs + 2}px ${spacing.xs + 6}px`,
	width: '140px',
}))

export const StyledEmail = styled('div')(() => ({
	fontSize: `${typography.fontSizeMd}px`,
	fontWeight: 500,
	color: colors.textPrimary,
	marginBottom: `${spacing.md}px`,
	wordBreak: 'break-all',
}))

export const StyledDivider = styled(Box)(() => ({
	height: '1px',
	backgroundColor: colors.divider,
	margin: `${spacing.sm}px 0`,
}))

export const StyledLogoutButton = styled('button')(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	width: '100%',
	border: 'none',
	backgroundColor: 'transparent',
	cursor: 'pointer',
	fontFamily: typography.fontFamily,
	textTransform: 'none',
	fontSize: `${typography.fontSizeMd}px`,
	color: colors.error,
	padding: `${spacing.sm}px 0`,
	'&:hover': {
		backgroundColor: 'transparent',
		textDecoration: 'underline',
	},
	'&:focus-visible': {
		...focusVisible,
	},
}))
